export interface ContractMapGuideTip
{
    imageSrc: string;
    title: string;
    paragraphs: string[];
}

/**
 * Tips de la guía del mapa, indexados por clave de paso (p. ej. "2.1").
 * Si un paso no tiene entrada (o array vacío), no se muestra el botón "Ver guía".
 */
export const ContractMapGuideTipsByStep: Record<string, ContractMapGuideTip[]> =
{
    "2.1":
    [
        {
            imageSrc: "./images/tips/step21/holders.webp",
            title: "Gestión de Intervinientes",
            paragraphs:
            [
                "En esta sección puedes introducir los datos de todas las personas que van a ser intervinientes en el contrato.",
                "Posteriormente decidirás cuales son las que participan y con qué papel lo hacen.",
                "No estás obligado a incluir a todos los intervinientes que tengas en tu cuenta en un contrato."
            ]
        },
        {
            imageSrc: "./images/tips/step21/documents.webp",
            title: "Documentos de Identificación",
            paragraphs:
            [
                "Necesitas tener dos archivos con tu documento de identificación: anverso y reverso en formato de imagen jpg, bmp, etc. o en formato pdf.",
                "Si tienes un solo archivo con anverso y reverso puedes utilizarlo dos veces, pero has de rellenar ambos campos.",
                "Sólo admitimos documentos nacionales de identidad españoles o NIE. No admitimos pasaportes ni carnés de conducir."
            ]
        },
        {
            imageSrc: "./images/tips/step21/income.webp",
            title: "Justificante de Ingresos",
            paragraphs:
            [
                "La normativa antifraude y de prevención de blanqueo de capitales nos obliga a saber de dónde proviene el dinero con el que vas a adquirir los productos financieros.",
                "Este justificante puede ser la declaración de la renta, una declaración de herencia, etc.",
                "Las facturas son gastos y no son válidas como justificante de ingresos."
            ]
        },
        {
            imageSrc: "./images/tips/step21/convenience.webp",
            title: "Conocer a nuestro cliente (KYC)",
            paragraphs:
            [
                "La normativa nos exige también conocer a nuestros clientes para poder realizar los contratos con ellos.",
                "Para ello, tendrás que rellenar para cada interviniente una serie de datos personales y responder a unas preguntas para determinar si puedes realizar inversiones.",
                "A esto se le conoce como 'Conocer a nuestro cliente' o 'KYC' (Know Your Customer).",
                "Recuerda, estas preguntas te protegen sobre posibles fraudes."
            ]
        }
    ]
};

export function getContractMapGuideTips(stepKey: string): ContractMapGuideTip[]
{
    return ContractMapGuideTipsByStep[stepKey] || [];
}

export function hasContractMapGuideTips(stepKey: string): boolean
{
    return getContractMapGuideTips(stepKey).length > 0;
}

export function getContractMapGuideTargetId(stepKey: string): string
{
    // querySelector no admite '.' sin escapar en un id (#x-2.1 → id "x-2" + class "1")
    const safeStepKey = stepKey.replace(/\./g, "-");
    return `contractMapGuideTarget-${safeStepKey}`;
}